import api from './api';

export interface CheckWhitelistResponse {
  isWhitelisted: boolean;
  hasPendingRequest: boolean;
  requestStatus?: string;
}

export interface BetaAccessRequestData {
  email: string;
  profession: string;
  intendedUse: string;
  location: string;
  useType: 'Personal' | 'Company';
  companyName?: string;
}

export interface BetaAccessResponse {
  success: boolean;
  message: string;
  status?: string;
}

export async function checkWhitelist(email: string): Promise<CheckWhitelistResponse> {
  const { data } = await api.post('betaaccess/check-whitelist', { email });
  return data;
}

export async function submitBetaAccessRequest(request: BetaAccessRequestData): Promise<BetaAccessResponse> {
  const { data } = await api.post('betaaccess/request', request);
  return data;
}
